export default "__VITE_ASSET__Ds3uYtS8__"